export default __webpack_public_path__ + "static/dach-60aaf56ae5de272d9ec72e4827a9a033.png";